import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpClient,
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { throwError, BehaviorSubject, Observable, of } from 'rxjs';
import { tap, catchError, switchMap, filter, take } from 'rxjs/operators';
import Swal from 'sweetalert2';

import { environment } from '@app/env-service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  private refreshTokenInProgress = false;
  private refreshTokenSubject :BehaviorSubject<any> = new BehaviorSubject<any>(
    null,
  );

  constructor(
    private http :HttpClient,
    private router :Router,
  ) {}

  intercept(
    request :HttpRequest<any>,
    next :HttpHandler,
  ) :Observable<HttpEvent<any>> {
    request = this.addAuthToken(request);

    return next.handle(request).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          return this.handle401Error(request, next);
        } else {
          return throwError(error);
        }
      }),
    );
  }

  handle401Error(request :HttpRequest<any>, next :HttpHandler) {
    if (!this.refreshTokenInProgress) {
      this.refreshTokenInProgress = true;
      this.refreshTokenSubject.next(null);

      const data = { token: localStorage.getItem(environment.refreshTokenKey) };

      return this.http.post(`${environment.url}/auth/refresh`, data).pipe(
        catchError((error :any) => {
          Swal.fire(
            'Session Timeout',
            'You will be redirected to the login page.',
            'error',
          ).then((_) => {
            window.location.reload();
          });

          return of('error');
        }),
        switchMap((tokens :any) => {
          if (tokens.access_token) {
            localStorage.setItem(environment.accessTokenKey, tokens.access_token);
            localStorage.setItem(environment.refreshTokenKey, tokens.refresh_token);
          }
          this.refreshTokenInProgress = false;
          this.refreshTokenSubject.next(true);

          return next.handle(this.addAuthToken(request));
        }),
      );
    } else {
      return this.refreshTokenSubject.pipe(
        filter((value) => value != null),
        take(1),
        switchMap((value) => {
          return next.handle(this.addAuthToken(request));
        }),
      );
    }
  }

  addAuthToken(request :HttpRequest<any>) {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${localStorage.getItem(environment.accessTokenKey)}`,
      },
    });
  }
}
